import { IWord } from '@dto';
import { CSSProperties } from '@mui/styles';
import { useGameContext } from 'context/GameContext';
import React, { memo, useCallback, useMemo, useState } from 'react';
import trans from 'translation';
import { KContainer, KLabel, KButton, KSpacingValue } from 'uikit';

const ReviewingJumble = () => {
  const { roomInfo, toggleJumbleStatistics } = useGameContext();

  const { teams = [] } = roomInfo || {};

  const [index, setIndex] = useState(0);

  // const wordText = useMemo(() => {
  //   switch (gameMode) {
  //     case E_GAME_MODES.WORD.id:
  //       return 'common.word';

  //     case E_GAME_MODES.SENTENCE.id:
  //       return 'common.sentence';

  //     case E_GAME_MODES.PARAGRAPH.id:
  //       return 'common.paragraph';

  //     default:
  //       return 'common.word';
  //   }
  // }, [gameMode]);

  const fadeStyles = useCallback((isVisible: boolean, translateX?: boolean) => {
    const result = {
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'scale(1)' : 'scale(1)',
      transition: 'opacity 0.3s ease, transform 0.3s ease'
    } as CSSProperties;

    if (translateX) {
      result.transform += ` translateX(${
        isVisible ? '-16px' : '-96px'
      }) rotate(${isVisible ? '0deg' : '360deg'})`;
    }

    return result;
  }, []);

  const slideStyle = useMemo(() => {
    return {
      display: 'flex',
      transition: 'transform 0.2s ease',
      transform: `translateX(calc(-${index * 100}% - ${
        index === 0 ? 0 : KSpacingValue['1.5rem']
      }px))`
    };
  }, [index]);

  const renderTeamWords = useCallback((teamId: string, words: IWord[]) => {
    return (
      <KContainer.View
        style={{
          minWidth: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
        gap="1rem"
      >
        {(words ?? [])
          .sort((a, b) => (a.order ?? Infinity) - (b.order ?? Infinity))
          .map(i => {
            const isSuccess = Number(i.score) > 0;

            return (
              <KContainer.View
                key={`${teamId}-word-${i.id}-${i.order}`}
                brW={1}
                br={'2x'}
                brC={isSuccess ? '#27AE60' : '#F77777'}
                background={isSuccess ? '#E2F8EB' : '#FFECED'}
                padding="0.75rem"
                paddingV="0.5rem"
              >
                <KLabel.Text>{i.texts[0]}</KLabel.Text>
              </KContainer.View>
            );
          })}
      </KContainer.View>
    );
  }, []);

  const len = teams.length - 1;

  const renderTeamList = useMemo(() => {
    return (teams ?? []).map((team, teamIndex) => {
      return (
        <KContainer.View
          key={team.id}
          style={{
            minWidth: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
          marginL={teamIndex === 0 ? 0 : '1.5rem'}
        >
          <KLabel.Paragraph
            typo="TextNmBold"
            marginH="0.25rem"
            marginB="0.5rem"
          >
            {trans('common.your_answer')}
          </KLabel.Paragraph>

          {renderTeamWords(team.id, team.words)}
        </KContainer.View>
      );
    });
  }, [renderTeamWords, teams]);

  return (
    <KContainer.View marginH={'1.5rem'}>
      <KContainer.View
        br={'4x'}
        background="#F7F7F7"
        padding={'1.5rem'}
        overflowY="scroll"
        maxH={400}
      >
        <KContainer.View marginB={'1.5rem'} alignItems>
          <KLabel.Text textAlign typo="TextLgBold" flex>
            {teams[index].name}
          </KLabel.Text>
        </KContainer.View>

        <KContainer.View row style={slideStyle}>
          {renderTeamList}
        </KContainer.View>
      </KContainer.View>

      <KContainer.View
        row
        alignItems
        marginT={'1.5rem'}
        marginB={'0.5rem'}
        justifyContent="flex-end"
      >
        <div style={fadeStyles(index > 0, true)}>
          <KButton.Solid
            width={100}
            title={trans('common.back')}
            onPress={() => setIndex(p => Math.min(p - 1, 0))}
          />
        </div>

        <div style={fadeStyles(true)}>
          <KButton.Solid
            width={100}
            title={trans('common.next')}
            onPress={() => {
              if (index === len) {
                toggleJumbleStatistics();
                return;
              }
              setIndex(p => Math.min(p + 1, len));
            }}
          />
        </div>
      </KContainer.View>
    </KContainer.View>
  );
};

ReviewingJumble.displayName = 'Containers.InGame.Reviewing.Jumble';

export default memo(ReviewingJumble);
